// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_hw-3";
export var flatBottomCorners = "_hw-5";
export var productImage = "_hw-0";
export var quantityContainer = "_hw-2";
export var quantityHeader = "_hw-6";
export var tooltip = "_hw-1";
export var wrapAndEllipsesOverflow = "_hw-4";